/* global globalThis */
import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { T } from '../../components/Translations';

/**
 *an area of data collapsing into a panel
 * @param {object} props  children, name, left, rounded
 */
export function Switchable({ children, name, left, rounded, hide, className, icon, switchContent, onShowStateChanged, ...restProps}) {
    const [show, setShow] = useState(!hide);

    const [isMobile, setIsMobile] = useState(globalThis.innerWidth <= 768);
  
    useEffect(() => {
        const handleResize = () => {
        setIsMobile(globalThis.innerWidth <= 768);
        };
        
        globalThis.addEventListener('resize', handleResize);
        return () => globalThis.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isMobile) {
            setShow(false);
        } else {
            setShow(true);
        }
    }, [isMobile]);

    const onSwitchClick = useCallback(() => {
        const newState = !show;
        setShow(newState);
        if(onShowStateChanged) { onShowStateChanged(newState); }
    }, [show, onShowStateChanged]);

    return <switchable 
        rounded={rounded && ""} 
        mini="" 
        left="" 
        overlay="adaptive" 
        className={`${show ? "" : "hide"} ${className || ''}`} {...restProps}
    >
        {!left && children}
        <switch onClick={onSwitchClick}>
            {switchContent || <><wrap><text><T>{name || 'text.filters'}</T></text></wrap>{icon}</>}
        </switch>
        {left && children}
    </switchable>
}

Switchable.propTypes = {
    children: PropTypes.node,
    name: PropTypes.string,
    left: PropTypes.bool,
    rounded: PropTypes.bool,
    hide: PropTypes.bool,
    className: PropTypes.string,
    icon: PropTypes.node,
    switchContent: PropTypes.node,
    onShowStateChanged: PropTypes.func
};